import { makeStyles } from 'tss-react/mui';

const name = 'Balance';

export const useBalanceStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));
